<template>
  <el-dialog title="" :visible.sync="visible" class="bet-match-dialog-components" :close-on-click-modal="false" :before-close="close" :show-close="true" width="6.46rem">
    <div class="content">
      <div class="content-top flex-row">
        <div class="diamonds-item flex-column flex-middle" :key="index" v-for="(item, index) in moneyList" @click="changeMoney(item)" :class="{ select: money == item.amount }">
          <img :src="require('@/assets/img/dialog/diamonds.png')" />
          <div class="diamonds-desc flex-middle">{{ item.amount }}</div>
        </div>
      </div>
      <div class="content-input">
        <el-input v-model="money" type="number" placeholder="自定义金额"></el-input>
      </div>

      <div class="padding-t-20 flex-middle">
        <div class="flex-middle">
          <div class="content-btn cancel-btn flex-middle" @click="close">取消</div>
          <div class="content-btn bet-btn flex-middle" @click="commit">下注</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { post } from "../../util/http";
export default {
  computed: {
    ...mapState(["userInfo", "appConfig", "chips"]),
    moneyList() {
      return this.chips.filter((item) => item.amount >= this.minBet);
    },
  },

  data() {
    return {
      visible: false,
      money: "",
      data: {},
      minBet: 0,
    };
  },
  created() {},
  destroyed() {},
  methods: {
    open(item = {}) {
      this.visible = true;
      this.data = item;
      this.minBet = item?.min_bet / 100;
      console.log("item: ", item);
    },

    close() {
      this.money = "";
      this.item = {};
      this.visible = false;
    },
    changeMoney(item = {}) {
      this.money = item?.amount || "";
    },
    commit() {
      if (!this.money) {
        this.$message({
          message: "请输入金额",
          type: "warning",
        });
      }
      if (!(Number(this.money) % 1 === 0)) {
        this.$message({
          message: "金额必须为整数",
          type: "warning",
        });
        return;
      }
      let data = {
        amount: Number(this.money) * 100,
        anchor_id: this.userInfo.id,
        g_id: this.data.g_id,
        guess_item: this.data.result,
        live_id: this.data.live_id,
      };

      post({
        url: "/api/guess/createGuessOrder",
        data,
      })
        .then(({ data: { data, status = "" } }) => {
          if (status == 0) {
            this.$message({
              message: "投注成功",
              type: "success",
              customClass: "ly-success",
            });
            this.$emit("getGuessOrderList");
            this.$store.dispatch("getUserInfo");
          } else {
            this.$message({
              message: "投注失败",
              type: "error",
              customClass: "ly-error",
            });
          }
          this.close();
        })
        .catch((err) => {
          console.warn("settleGuess err: ", err);
        });
    },
  },
};
</script>

<style scoped lang="stylus">
.bet-match-dialog-components{
  z-index:1;

  .content{
	.content-top{
		flex-wrap: wrap;
		.diamonds-item{
			width : 1rem;
			height : 1rem;
			margin-bottom: .05rem;
			margin : .1rem .1rem;
			background: #F9F9FB;
			border: 1px dashed #F0F0F0;
			border-radius: 5px;
			cursor : pointer;
			&:hover,&.select{
				background: rgba(2, 168, 162, 0.1);
				border-color: #02A8A2;
				.diamonds-desc{
					background: linear-gradient(90deg, #29F19C 0%, #02A1F9 100%);
				}
			}
			img{
				width : .6rem;
			}
			.diamonds-desc{
				background : #02A8A2;
				border-radius: 5px;
				width : .55rem;
				height : .23rem;
				color : #ffffff;
				border: 1px solid #FF8F00;
				// transform: translateY(-90%);
				margin-top : -0.15rem;
			}

		}
	}
	.content-input{
		margin : .1rem 0rem;
		/deep/ .el-input__inner{
			background : #F4F4F4;
		}
	}
	.content-btn{
		border: 1px solid #02A8A2;
		border-radius: 1rem;
		width : 1.3rem;
		height : .4rem;
		margin : 0 .1rem;
		font-size : .16rem;
		cursor : pointer;
	}
	.cancel-btn{
		border-color : #02A8A2;
		color : #02A8A2;
	}
	.bet-btn{
		background: #02A8A2;
		color : #ffffff;
	}
}

/deep/{
	.el-dialog__header{
		display : none;
	}
	.el-dialog{
		border-radius: 10px;
	}
	.el-form-item{
		margin-bottom : 10px;
	}
	.el-input--small .el-input__icon{
		line-height : 40px;
	}
	.el-dialog__body{
		padding: 30px 20px;
		color: #606266;
		font-size: 14px;
		word-break: break-all;
	}
}

}
</style>
